module.exports = __webpack_public_path__ + "static/media/protein-subunit.a0e73de9.jpg";